import { render, staticRenderFns } from "./SolicitacaoJustificar.vue?vue&type=template&id=772746b6&scoped=true&"
import script from "./SolicitacaoJustificar.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoJustificar.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoJustificar.vue?vue&type=style&index=0&id=772746b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772746b6",
  null
  
)

export default component.exports